import { GET_ALL_STAFF } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export interface Response {
    success: boolean;
    data: StaffData[];
}
export interface StaffData {
    mobile: string;
    soid: string;
    fln: string;
    scope: string;
}

export default (): Promise<Response> => {
    return fetchWithRefresh(GET_ALL_STAFF).then((res) => res.json());
};
